document.addEventListener('DOMContentLoaded', () => {
   const swiperEls = document.querySelectorAll("swiper-container");

   swiperEls.forEach((swiperEl) => {
      Object.assign(swiperEl, {
         injectStylesUrls: ["//unitedicons.nl/cdn/shop/t/2/assets/swiper-theme.css?v=82582321640911491581763983444"],
      });
   });
});